import React from "react";

export const OpenDay = ({ day, open, close, onRemove }) => {
  return (
    <div className="row my-2 ">
      <span className="col-4">{day}</span>
      <span className="col-6">
        <span className="mr-2">{open}</span>
        {close === "24 hours" ? null : <span>-</span>}
        <span className="ml-2">{close}</span>
      </span>
      <span className="col-2">
        <button
          onClick={() => onRemove()}
          className="btn p-0 border-0 removebtn btn-outline-danger"
        >
          Remove
        </button>
      </span>
    </div>
  );
};
